import { createContext } from 'react';

export const HoneycombLoadingContext = createContext<boolean | undefined>(
  undefined,
);
